export default "__VITE_ASSET__DQSF39LY__"